
<template>
    <v-overlay class="transparent">
        <v-container class="align-center justify-center fill-height">
            <v-row class="d-block pa-10 colored-box">
                <v-row class="d-block blue-color heading-font-family">
                    <strong>{{ $t('AHA COOKIE INFORMATION') }}</strong>
                </v-row>
                <v-spacer class="mt-2"></v-spacer>
                <v-row class="d-block gray-color">
                    {{ $t('We use cookies to ensure the functionality of the site. We also use cookies, which are necessary for analysis and advertising purposes. You can find all information on this in our') }}
                    <a :href="$t('/datenschutzrichtlinien')" class="blue-color plain-link">{{ $t('data protection regulations.') }}</a>
                </v-row>
                <v-spacer class="mt-7"></v-spacer>
                <v-row v-if="showPreferences" class="preferences">
                    <v-col>
                        <v-row class="justify-start align-center">
                            <v-checkbox aria-checked="true" light checked v-model="checkboxRequired" name="required" disabled />
                            <a :href="$t('/notwendige-cookies')" class="blue-color plain-link heading-font-family"><strong>{{ $t('NECESSARY') }}</strong></a>
                        </v-row>
                        <v-row>
                            <p class="gray--text text--darken-5">
                                {{ $t('These cookies are necessary so that you can use the aha offer.') }}
                            </p>
                        </v-row>
                    </v-col>
                    <v-col>
                        <v-row class="justify-start align-center">
                            <v-checkbox light v-model="checkboxMarketing" />
                            <a :href="$t('/marketing-cookies')" class="blue-color plain-link heading-font-family"><strong>{{ $t('MARKETING-COOKIES') }}</strong></a>
                        </v-row>
                        <v-row>
                            <p class="gray--text text--darken-5">
                                {{ $t('These cookies are used for analytics and advertising purposes.') }}
                            </p>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="justify-space-between" style="width: 100%;">
                    <v-btn v-if="!showPreferences" light @click="showPreferences = !showPreferences">
                        {{ $t('Cookie Preferences') }}
                    </v-btn>
                
                    <v-btn v-else color="primaryDark" light @click="confirmCookies">
                        {{ $t('Save Preferences') }}
                    </v-btn>

                    <v-btn color="primary" dark @click="confirmCookies" class="accept-all">
                        {{ $t('Accept all cookies') }}
                    </v-btn>
                </v-row>
            </v-row>
        </v-container>
    </v-overlay>
</template>

<style scoped>
    .colored-box {
        background-color: #ffffff !important;
        min-width: 960px;
    }
    .gray-color {
        color: #595959;
    }
    .blue-color {
        color: #6D81B9;
    }
    a.plain-link {
        text-transform: none;
        height: auto;
        padding: 0px 0px;
        text-decoration: none;
        opacity: 0.9;
    }
    a.plain-link:hover {
        text-decoration: underline;
        opacity: 1;
    }
    .row button.v-btn {
        padding: 27px 47px;
    }
    .row button.v-btn.theme--light:hover {
        color: #595959;
        background-color: #d0d0d8;
        border-color: #adadad;
    }
    .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        color: #595959;
        background-color: #ECECEF;
        border-color: #ccc;
        box-shadow: none;
    }
    .heading-font-family {
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .row.colored-box {
            max-width: 95%;
            min-width: auto;
        }
        .v-overlay.transparent {
            position: relative;   
            height: 100%; 
        }
        .row button.v-btn {
            padding: 27px 34px;
        }
        .accept-all {
            margin-top: 20px;
        }
        .preferences {
            flex-direction: column;
        }
    }
</style>

<script>
export default {
    data () {
      return {
        checkboxRequired: true,
        checkboxMarketing: false,
        showPreferences: false,
      }
    },
    methods: {
        confirmCookies() {
            this.$persistentStorage.confirmCookies({consent: this.checkboxRequired, marketing: this.checkboxMarketing});
        },
    },
};
</script>
